export const MESSAGES_SEARCH_REQUESTED = 'MESSAGES_SEARCH_REQUESTED';
export const MESSAGES_SEARCH_SUCCEED = 'MESSAGES_SEARCH_SUCCEED';
export const MESSAGES_SEARCH_FAILED = 'MESSAGES_SEARCH_FAILED';

export const MESSAGES_SEARCH_LOAD_MORE_REQUESTED = 'MESSAGES_SEARCH_LOAD_MORE_REQUESTED';
export const MESSAGES_SEARCH_LOAD_MORE_SUCCEED = 'MESSAGES_SEARCH_LOAD_MORE_SUCCEED';
export const MESSAGES_SEARCH_LOAD_MORE_FAILED = 'MESSAGES_SEARCH_LOAD_MORE_FAILED';
